import { render, staticRenderFns } from "./TraderStatistics.vue?vue&type=template&id=3e55fd31&scoped=true&"
import script from "./TraderStatistics.vue?vue&type=script&lang=js&"
export * from "./TraderStatistics.vue?vue&type=script&lang=js&"
import style0 from "../../styles/button.less?vue&type=style&index=0&id=3e55fd31&lang=less&scoped=true&"
import style1 from "./TraderStatistics.vue?vue&type=style&index=1&id=3e55fd31&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e55fd31",
  null
  
)

export default component.exports